import { Route }               from 'react-router-dom';
import StandDocumentsList      from './views/StandDocumentsList';
import StandDocumentsDashboard from './views/StandDocumentsDashboard';

export default [
  <Route element={<StandDocumentsList />} key="list" path="/salons/:showId/documents" />,
  <Route element={<StandDocumentsDashboard />} key="show" path="/stands/:id/documents" />,
];
